<template>
  <div>
    <v-layout v-if="!isReportsViewAllowed">
      <v-flex class="text-center error pa-2">
        <h1 class="title">{{$t('Errors.AccessDeniedAuthorizationFailed')}}</h1>
      </v-flex>
    </v-layout>
    <template v-else>
      <v-layout wrap>
        <v-flex xs12 md3>
          <template v-if="$root.isFullFinancialDataAllowedToView">
            <input
              style="display: none"
              type="file"
              ref="import_expenses_file_from_pilot"
              :multiple="false"
              accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              @change="e => importExpensesUpload(e, 'pilot')"
            />
            <input
              style="display: none"
              type="file"
              ref="import_expenses_file_from_fleet_one"
              :multiple="false"
              accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              @change="e => importExpensesUpload(e, 'fleetOne')"
            />
            <input
              style="display: none"
              type="file"
              ref="import_expenses_file_from_tcs"
              :multiple="false"
              accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              @change="e => importExpensesUpload(e, 'tcs')"
            />
          </template>
        </v-flex>
        <!--<v-flex xs12 md3 v-else-if="!$root.isMobile" class="text-no-wrap">
          <v-btn small class="ma-1" @click="onPrintBtn()"><v-icon left>mdi-printer</v-icon>Print</v-btn>
          <v-btn small class="ma-1" @click="onPrintSelectedBtn()" :disabled="selectedStr.length === 0"><v-icon left>mdi-printer</v-icon>Print Selected</v-btn>
        </v-flex>-->
        <v-flex xs12 md6 class="text-center">
          <v-layout v-if="mode !== 'all'">
            <v-flex grow class="text-right">
              <v-btn text :small="$root.isMobile" class="mr-1" @click="prevInterval" :disabled="isRangeMode">
                <v-icon :small="$root.isMobile">mdi-chevron-left</v-icon>
              </v-btn>
            </v-flex>
            <v-flex shrink class="pt-1">
              <date-range-picker :key="dateRangePickerKey"
                                 v-model="dateRange"
                                 :options="dateRangeOptions"
                                 format="MM/DD/YYYY"
                                 :style="$vuetify.theme.dark ? {color:'#fff', fontSize: $root.isMobile ? '0.9rem' : '1rem', width: $root.isMobile ? '180px' : '200px'} : {fontSize: $root.isMobile ? '0.9rem' : '1rem', width: $root.isMobile ? '180px' : '200px'}"
                                 @input="dateRangeChange"/>
            </v-flex>
            <v-flex grow class="text-left">
              <v-btn text :small="$root.isMobile" class="ml-1" :disabled="offset <= 0 || isRangeMode" @click="nextInterval" >
                <v-icon :small="$root.isMobile">mdi-chevron-right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <!--<v-flex xs2 v-if="$root.isMobile">
          <v-btn small icon class="ml-2" @click="onPrintBtn()"><v-icon left>mdi-printer</v-icon></v-btn>
        </v-flex>-->
        <v-flex xs12 md3 class="text-right">
          <v-btn-toggle v-model="mode" style="margin-top:-10px;" tile dense group mandatory @change="onTimeFrameChanged">
            <v-btn value="range" disabled v-show="mode==='range'">Range</v-btn>
            <v-btn value="day" @click="onTimeFrameChanged">1d</v-btn>
            <v-btn value="week" @click="onTimeFrameChanged">1w</v-btn>
            <v-btn value="month" @click="onTimeFrameChanged">1m</v-btn>
            <v-btn value="year" @click="onTimeFrameChanged">1y</v-btn>
            <v-btn value="all" @click="onTimeFrameChanged">all</v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
      <template v-if="!$root.isFullFinancialDataAllowedToView && dateRange.length > 0">
        <DriverReport v-if="$store.getters.isUserRoleDriver && isDriversReportsViewAllowed"
                      :key="dateRange[0] + dateRange[1]"
                      :from="$root.parseDate(dateRange[0])"
                      :to="$root.parseDate(dateRange[1])"
                      :driverId="$store.getters.currentUser.id"
                      :isShiftOnly="true"/>
        <DriverOOReport v-if="$store.getters.isUserRoleDriverOO && isDriversOwnerOperatorsReportsViewAllowed"
                        :key="dateRange[0] + dateRange[1]"
                        :from="$root.parseDate(dateRange[0])"
                        :to="$root.parseDate(dateRange[1])"
                        :driverId="$store.getters.currentUser.id"/>
        <DispatcherReport v-if="$store.getters.isUserRoleDispatcher && isDispatchersReportsViewAllowed"
                          :key="dateRange[0] + dateRange[1] + $route.params.item"
                          :from="$root.parseDate(dateRange[0])"
                          :to="$root.parseDate(dateRange[1])"
                          @show-map-modal="openMapInModal"
                          :dispatcherId="$store.getters.currentUser.id"/>
      </template>
      <template v-else-if="$root.isFullFinancialDataAllowedToView">
        <v-layout>
          <v-flex xs12>
            <v-select v-if="$root.isMobile"
                      class="mb-2"
                      :items="reportTypesItems"
                      @change="onReportTypeChanged('')"
                      dense outlined hide-details
                      :label="$t('Reports.Type')"
                      v-model="tab"
            />

            <v-select v-if="$root.isMobile && $route.params.type === 'trucks'"
                      v-model="selectedTruckItem"
                      outlined
                      hide-details
                      dense
                      class="mb-1"
                      :label="$root.t('Loads.Truck')"
                      :items="trucksList"
                      item-text="name"
                      item-value="id"
                      @change="(val) => { onReportSubTypeChanged('/reports/trucks/' + val) }"
            />

            <v-select v-if="$root.isMobile && $route.params.type === 'dispatchers'"
                      v-model="selectedDispatcherItem"
                      outlined
                      hide-details
                      dense
                      class="mb-1"
                      :label="$root.t('Loads.Dispatcher')"
                      :items="dispatchersList"
                      item-text="fullName"
                      item-value="id"
                      @change="(val) => { onReportSubTypeChanged('/reports/dispatchers/' + val) }"
            />

            <v-select v-if="$root.isMobile && ($route.params.type === 'drivers' || $route.params.type === 'driversLoads')"
                      v-model="selectedDriverItem"
                      outlined
                      hide-details
                      dense
                      class="mb-1"
                      :label="$root.t('Loads.Driver')"
                      :items="driversList"
                      item-text="fullName"
                      item-value="id"
                      @change="(val) => { onReportSubTypeChanged('/reports/drivers/' + val) }"
            />
            <v-tabs v-model="tab" grow show-arrows v-if="!$root.isMobile" active-class="tabs-active-color">
              <v-tab v-if="isTrucksReportsViewAllowed" key="trucks" href="#trucks" @click="onReportTypeChanged('/reports/trucks/')">{{ $t('Reports.Trucks') }}</v-tab>
              <v-tab v-if="isLoadsReportsViewAllowed" key="loads" href="#loads" @click="onReportTypeChanged('/reports/loads')">{{ $t('Reports.Loads') }}</v-tab>
              <v-tab v-if="isInvoicesReportsViewAllowed" key="invoices" href="#invoices" @click="onReportTypeChanged('/reports/invoices')">{{ $t('Reports.Invoices') }}</v-tab>
              <v-tab v-if="isDriversReportsViewAllowed" key="drivers" href="#drivers" @click="onReportTypeChanged('/reports/driversLoads/')">{{ $t('Reports.Drivers') }}</v-tab>
              <v-tab v-if="isDriversOwnerOperatorsReportsViewAllowed" key="driversOO" href="#driversOO" @click="onReportTypeChanged('/reports/driversOO/')">{{ $t('Reports.DriversOO') }}</v-tab>
              <v-tab v-if="isDispatchersReportsViewAllowed" key="dispatchers" href="#dispatchers" @click="onReportTypeChanged('/reports/dispatchers/')">{{ $t('Reports.Dispatchers') }}</v-tab>
              <v-tab v-if="isAccountantsReportsViewAllowed" key="accountants" href="#accountants" @click="onReportTypeChanged('/reports/accountants/')">{{ $t('Reports.Accountants') }}</v-tab>
              <v-tab v-if="isLoadsFeedReportsViewAllowed" key="loadsFeed" href="#loadsFeed" @click="onReportTypeChanged('/reports/loadsFeed/')">{{ $t('Reports.LoadsFeed') }}</v-tab>
              <v-tab v-if="isLoadsVerificationReportsViewAllowed" key="loadsRefines" href="#loadsRefines" @click="onReportTypeChanged('/reports/loadsRefines/')">{{ $t('Reports.LoadsRefines') }}</v-tab>
              <v-tab v-if="isTrucksMaintenanceReportsViewAllowed" key="truckMaintenance" href="#truckMaintenance" @click="onReportTypeChanged('/reports/truckMaintenance/')">{{ $t('Reports.TruckMaintenance') }}</v-tab>
              <v-tab v-if="isExpensesReportsViewAllowed" key="expenses" href="#expenses" @click="onReportTypeChanged('/reports/expenses/')">{{ $t('Reports.Expenses') }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab" :touchless="true">
              <v-tab-item v-if="isLoadsFeedReportsViewAllowed" key="loadsFeed" value="loadsFeed">
                <LoadsFeedReport :from="$root.parseDate(dateRange[0])"
                                 :to="$root.parseDate(dateRange[1])"
                                 :key="dateRange[0] + dateRange[1]"/>
              </v-tab-item>

              <v-tab-item v-if="isLoadsVerificationReportsViewAllowed" key="loadsRefines" value="loadsRefines">
                <LoadsRefinesReport :from="$root.parseDate(dateRange[0])"
                                    :to="$root.parseDate(dateRange[1])"
                                    :key="dateRange[0] + dateRange[1]"/>
              </v-tab-item>

              <v-tab-item v-if="isTrucksMaintenanceReportsViewAllowed" key="truckMaintenance" value="truckMaintenance">
                <TruckMaintenanceReport :from="$root.parseDate(dateRange[0])"
                                        :to="$root.parseDate(dateRange[1])"
                                        :key="dateRange[0] + dateRange[1]"
                                        :selectedStr="selectedStr"/>
              </v-tab-item>

              <v-tab-item v-if="isExpensesReportsViewAllowed" key="expenses" value="expenses">
                <ExpensesReport :from="$root.parseDate(dateRange[0])"
                                :to="$root.parseDate(dateRange[1])"
                                :key="dateRange[0] + dateRange[1]"
                                :importPilotLoading="importPilotLoading"
                                :importFleetOneLoading="importFleetOneLoading"
                                :importTCSLoading="importTCSLoading"
                                :selectedStr="selectedStr"
                                @on-import-from-pilot="$refs.import_expenses_file_from_pilot.click()"
                                @on-import-from-fleet-one="$refs.import_expenses_file_from_fleet_one.click()"
                                @on-import-from-tcs="$refs.import_expenses_file_from_tcs.click()"
                />
              </v-tab-item>

              <v-tab-item v-if="isTrucksReportsViewAllowed" key="trucks" value="trucks">
                <v-layout v-if="$route.params.type === 'trucks' && !$route.params.item">
                  <v-flex xs12 v-if="$root.parseDate(dateRange[0]) && $root.parseDate(dateRange[1])">
                    <TrucksTotalsList :from="$root.parseDate(dateRange[0])" :to="$root.parseDate(dateRange[1])" :key="dateRange[0] + dateRange[1]"/>
                  </v-flex>
                </v-layout>
                <div v-if="$route.params.type === 'trucks' && $route.params.item">
                  <TruckReport :key="truckReportKey"
                               :from="$root.parseDate(dateRange[0])"
                               :to="$root.parseDate(dateRange[1])"
                               :truckId="$route.params.item"
                               :truckName="'truck.name'"
                               @selected="onSelected"
                               @show-map-modal="openMapInModal"
                               :selectedStr="selectedStr"/>
                </div>
              </v-tab-item>

              <v-tab-item v-if="isDriversReportsViewAllowed" key="drivers" value="drivers">
                <v-layout v-if="($route.params.type === 'drivers' || $route.params.type === 'driversLoads') && !$route.params.item">
                  <v-flex xs12 v-if="$root.parseDate(dateRange[0]) && $root.parseDate(dateRange[1])">
                    <DriversTotalsList :from="$root.parseDate(dateRange[0])" :to="$root.parseDate(dateRange[1])" :key="dateRange[0] + dateRange[1]"/>
                  </v-flex>
                </v-layout>
                <div v-if="($route.params.type === 'drivers' || $route.params.type === 'driversLoads') && $route.params.item > 0">
                  <DriverShiftsReport v-if="$route.params.type === 'drivers'" :key="driversReportKey"
                                      :from="$root.parseDate(dateRange[0])"
                                      :to="$root.parseDate(dateRange[1])"
                                      :driverId="$route.params.item"
                                      @selected="onSelected"
                                      @back-to-list="onReportSubTypeChanged('/reports/drivers')"
                                      @show-map-modal="openMapInModal"
                                      :driverName="getDriverFullNameById($route.params.item)"
                                      :selectedStr="selectedStr"/>
                </div>
              </v-tab-item>

              <v-tab-item v-if="isDriversOwnerOperatorsReportsViewAllowed" key="driversOO" value="driversOO">
                <v-select v-if="$root.isMobile"
                          :items="driversOOList"
                          :label="$t('Reports.DriversOO')"
                          :value="parseInt($route.params.item)"
                          item-value="id"
                          item-text="fullName"
                          class="mt-2"
                          @change="(val) => { onReportSubTypeChanged('/reports/' + $route.params.type + '/' + val); }"
                          dense outlined
                />
                <v-tabs v-model="driversOOTabs" grow show-arrows active-class="tabs-active-color" v-else>
                  <template v-for="(driver) in driversOOList">
                    <v-tab :key="'driverOO_'+driver.id" :href="'#driverOO_'+driver.id" @click="onReportSubTypeChanged('/reports/' + $route.params.type + '/' + driver.id)">
                      <v-avatar :size="32" class="ma-1" :color="(driver.fullName && !driver.avatar)?'#015aaa':null">
                        <v-img v-if="driver.avatarUPLOAD" :src="$root.getImageUrl('avatar', driver.avatarUPLOAD)"></v-img>
                        <span class="white--text" v-else-if="driver.fullName && driver.avatarLetters">{{driver.avatarLetters}}</span>
                        <v-icon large v-else-if="driver.fullName === 'All'">mdi-account-supervisor-circle</v-icon>
                        <v-icon large v-else>account_circle</v-icon>
                      </v-avatar>
                      {{driver.fullName}}
                    </v-tab>
                  </template>
                </v-tabs>
                <v-tabs-items v-model="driversOOTabs" :touchless="true">
                  <template v-for="(driver) in driversOOList">
                    <v-tab-item :key="'driverOO_'+driver.id" :value="'driverOO_'+driver.id">
                      <DriverOOReport v-if="$route.params.type === 'driversOO'"
                                      :key="driversOOReportKey"
                                      :from="$root.parseDate(dateRange[0])"
                                      :to="$root.parseDate(dateRange[1])"
                                      :driverId="driver.id"
                                      @selected="onSelected"
                                      :selectedStr="selectedStr"></DriverOOReport>
                    </v-tab-item>
                  </template>
                </v-tabs-items>
              </v-tab-item>

              <v-tab-item v-if="isDispatchersReportsViewAllowed" key="dispatchers" value="dispatchers">
                <v-layout wrap v-if="$route.params.type === 'dispatchers' && !$route.params.item">
                  <v-flex xs12 v-if="$root.parseDate(dateRange[0]) && $root.parseDate(dateRange[1])">
                    <DispatchersTotalsList :from="$root.parseDate(dateRange[0])" :to="$root.parseDate(dateRange[1])" :key="dateRange[0] + dateRange[1]"/>
                  </v-flex>
                </v-layout>
                <div v-else-if="$route.params.type === 'dispatchers' && $route.params.item">
                <DispatcherReport v-if="$route.params.type === 'dispatchers'" :key="dateRange[0] + dateRange[1] + $route.params.item"
                                  :from="$root.parseDate(dateRange[0])"
                                  :to="$root.parseDate(dateRange[1])"
                                  :dispatcherId="$route.params.item"
                                  @selected="onSelected"
                                  @show-map-modal="openMapInModal"
                                  :selectedStr="selectedStr"/>
                </div>
              </v-tab-item>

              <v-tab-item v-if="isAccountantsReportsViewAllowed" key="accountants" value="accountants">
                <v-layout wrap v-if="$route.params.type === 'accountants' && !$route.params.item">
                  <v-flex xs12 v-if="$root.parseDate(dateRange[0]) && $root.parseDate(dateRange[1])">
                    <AccountantsTotalsList :from="$root.parseDate(dateRange[0])"
                                           :to="$root.parseDate(dateRange[1])"
                                           :key="dateRange[0] + dateRange[1]"
                                           :accountantId="$route.params.item"
                                           />
                  </v-flex>
                </v-layout>
                <div v-else-if="$route.params.type === 'accountants' && $route.params.item">
                <AccountantsReport v-if="$route.params.type === 'accountants'" :key="dateRange[0] + dateRange[1] + $route.params.item"
                                  :from="$root.parseDate(dateRange[0])"
                                  :to="$root.parseDate(dateRange[1])"
                                  :accountantId="$route.params.item"
                                  @selected="onSelected"
                                  @show-map-modal="openMapInModal"
                                  :selectedStr="selectedStr"/>
                </div>
              </v-tab-item>

              <v-tab-item v-if="isLoadsReportsViewAllowed" key="loads" value="loads">
                <LoadsReport  v-if="$route.params.type === 'loads'"
                              :key="loadsReportKey"
                              :from="$root.parseDate(dateRange[0])"
                              :to="$root.parseDate(dateRange[1])"
                              @selected="onSelected"
                              @show-map-modal="openMapInModal"
                              :selectedStr="selectedStr"></LoadsReport>
              </v-tab-item>
              <v-tab-item v-if="isInvoicesReportsViewAllowed" key="invoices" value="invoices">
                <InvoicesReport  v-if="$route.params.type === 'invoices'"
                                 :key="invoicesReportKey"
                                 :from="$root.parseDate(dateRange[0])"
                                 :to="$root.parseDate(dateRange[1])"
                                 @selected="onSelected"
                                 :selectedStr="selectedStr"></InvoicesReport>
              </v-tab-item>
            </v-tabs-items>
          </v-flex>
        </v-layout>
        <v-dialog v-model="mapModal">
          <v-card tile>
            <v-card-title>
              {{mapModalStartLocation}} -- {{mapModalEndLocation}}
              <span :style="{ color: $root.isDark ? '#121e2d' : '#fff' }">{{osmMapKey}}</span>
              <v-spacer/>
              <v-btn icon @click="mapModal=false;"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            {{ mapModalStarted }}
            <GoogleMapLoader v-if="$root.isUseGoogleMaps"
                             height="80vh"
                             ref="mapModalRef"
                             :showTraffic="false"
                             :showTrucks="false"
                             :waypoints="mapModalLocations"
                             :loadStarted="mapModalStarted"
                             :loadEnded="!mapModalEnded ? $root.getCurrentTimestamp() : mapModalEnded"
                             :trucks="mapModalLoadTrucks"
                             :loadId="mapModalLoadId"
                             :dontDrawTruckPaths="false"
                             :drawPathByWaypoints="false"
                             :showCustomIcons="true"
                             />
            <OSMMapLoader v-else
                          height="80vh"
                          ref="osmMap"
                          :key="osmMapKey"
                          :dontDrawTruckPaths="true"
                          :loadStarted="mapModalStarted"
                          :loadEnded="!mapModalEnded ? $root.getCurrentTimestamp() : mapModalEnded"
                          :trucks="mapModalLoadTrucks"
                          :loadId="mapModalLoadId"
                          :waypoints="mapModalLocations.length > 1 ? mapModalLocations.filter((e) => e.lat !== 0 && e.lng !== 0) : null"
                          :marker="mapModalLocations.length === 1 ? mapModalLocations[0] : null"/>
          </v-card>
        </v-dialog>

        <div id="floatingMapId" v-if="!$root.isUseGoogleMaps" v-show="$root.floatingMap" style="position: fixed;">
          <v-card tile>
            <v-card-title>{{mapModalStartLocation}} -- {{mapModalEndLocation}}</v-card-title>
            <!--<GoogleMapLoader v-if="$root.isUseGoogleMaps"
                             :height="'500px'"
                             ref="mapModalRef"
                             :showTraffic="false"
                             :showTrucks="false"
                             :waypoints="mapModalLocations"
                             :loadStarted="mapModalStarted"
                             :loadEnded="!mapModalEnded ? $root.getCurrentTimestamp() : mapModalEnded"
                             :truckId="mapModalLoadTruckId || 0"
                             :trucks="[]"
                             :loadId="mapModalLoadId"
                             :dontDrawTruckPaths="false"
                             :drawPathByWaypoints="false"
                             :showCustomIcons="true"
            />-->
            <OSMMapLoader v-if="!$root.isUseGoogleMaps && !mapModal"
                          height="500px"
                          ref="osmMapFloating"
                          :key="osmMapFloatingKey"
                          :dontDrawTruckPaths="true"
                          :waypoints="mapModalLocations.length > 1 ? mapModalLocations.filter((e) => e.lat !== 0 && e.lng !== 0) : null"
                          :marker="mapModalLocations.length === 1 ? mapModalLocations[0] : null"/>
          </v-card>
        </div>

        <v-dialog v-model="$root.isChangePaidDateModal" max-width="350px">
          <v-card tile>
            <v-card-title>
              <h2>Payment Submit</h2><v-spacer></v-spacer><v-btn icon @click="$root.isChangePaidDateModal=false;"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pt-5">
              <v-text-field
                label="Paid Date\Time"
                v-model="$root.changePaidDateTime"
                :rules="$root.datetimeUSARule"
                outlined
                hide-details
                dense
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-2" @click="updateSelectedAsPaid">{{$t('Reports.UpdateSelectedDT')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="importModal">
          <v-card>
            <v-card-title>
              <h2>Import Expenses</h2>
              <v-spacer/>
              <small>New: {{importNewCount}}<br/> Already Imported: {{importImportedCount}}</small>
              <v-spacer/>
              <v-switch v-model="hideImported"
                        class="mr-2"
                        label="Hide Imported"
                        dense
                        inset
              />
              <v-text-field
                class="mt-1"
                v-model="importSearch"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                single-line
                outlined dense
                hide-details
              />
              <v-spacer/><v-btn icon @click="importModal=false;"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
            <v-card-text class="pa-2">
              <v-data-table :headers="importHeaders"
                            :items="importItemsFiltered"
                            :search="importSearch"
                            fixed-header
                            show-select
                            v-model="importSelected"
                            height="800"
                            hide-default-footer
                            disable-pagination>
                <template v-slot:item.importBtn="{ item }">
                  <v-chip v-if="item.error" color="error">{{item.error}}</v-chip>
                  <v-chip v-else-if="item.exists" color="success">Imported</v-chip>
                  <v-btn class="primary" v-else @click="importExpense(item)"><v-icon left>mdi-import</v-icon>Import</v-btn>
                </template>
                <template v-slot:item.loadId="{ item }">
                  <v-layout v-for="load in item.loads" class="mt-4">
                    <v-flex shrink class="pt-4">
                      <a href="#" @click.stop="$root.onShowLoadPreview(load.id)">#{{load.id}}</a>&nbsp;
                      <br/><span class="text-no-wrap">{{load.pickupLocationName}}</span>
                      <br/><span class="text-no-wrap">{{load.deliveryLocationName}}</span>
                    </v-flex>
                  </v-layout>
                </template>
                <template v-slot:item.driverId="{ item }">
                  <v-layout v-for="load in item.loads" class="mt-4">
                    <v-flex shrink class="pt-4" style="min-width: 100px;">
                      <v-select
                        v-if="load.drivers.length > 0"
                        dense outlined
                        label="Drivers"
                        item-value="id"
                        item-text="name"
                        v-model="load.firstDriver"
                        :items="load.drivers"
                      ></v-select>
                      <span v-else>No Drivers</span>
                    </v-flex>
                  </v-layout>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn class="primary" :disabled="importSelected.length === 0" :loading="importLoading" @click="importSelectedExpenses"><v-icon left>mdi-file-import</v-icon>Import Selected</v-btn>
              <v-btn @click="() => { importModal = false; }">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </template>
  </div>
</template>

<script>
import TruckReport from './TruckReport.vue';
import LoadsReport from './LoadsReport.vue';
import InvoicesReport from './InvoicesReport.vue';
import DriverShiftsReport from './DriverShiftsReport.vue';
import DriverLoadsReport from './DriverLoadsReport.vue';
import DriverOOReport from './DriverOOReport.vue';
import DispatcherReport from './DispatcherReport.vue';
import DispatchersTotals from './DispatchersTotals';
import DispatchersTotalsList from './DispatchersTotalsList';
import AccountantsReport from './AccountantsReport.vue';
import AccountantsTotals from './AccountantsTotals.vue';
import AccountantsTotalsList from './AccountantsTotalsList.vue';
import reportsMixin from '../../mixins/reportsMixin.js';
import DriverTotals from './DriverTotals';
import DriversTotalsList from './DriversTotalsList'
import TruckTotals from './TruckTotals';
import TrucksTotalsList from './TrucksTotalsList';
import LoadsFeedReport from './LoadsFeedReport';
import LoadsRefinesReport from './LoadsRefinesReport';
import TruckMaintenanceReport from './TruckMaintenanceReport';
import ExpensesReport from './ExpensesReport';
import ReportsGroupsList from './ReportsGroupsList';
import GoogleMapLoader from '../../components/GoogleMapLoader';
import OSMMapLoader from '../../components/OSMMapLoader';

export default {
  name: 'ReportIndex',
  components: {
    GoogleMapLoader,
    LoadsFeedReport,
    TruckReport,
    LoadsReport,
    InvoicesReport,
    DriverLoadsReport,
    DriverShiftsReport,
    DriverOOReport,
    DriverTotals,
    TruckTotals,
    DispatcherReport,
    DispatchersTotals,
    DispatchersTotalsList,
    AccountantsReport,
    AccountantsTotals,
    AccountantsTotalsList,
    LoadsRefinesReport,
    DriversTotalsList,
    TrucksTotalsList,
    TruckMaintenanceReport,
    ReportsGroupsList,
    ExpensesReport,
    OSMMapLoader },
  mixins: [reportsMixin],
  data: function () {
    return {
      loading: false,
      mounted: false,
      dateRange: [],
      offset: 0,
      mode: 'month',
      timeframe: 'month',
      dateRangePickerKey: new Date().getTime(),
      dateRangeOptions: {},
      tab: 'trucks',
      trucksList: [],
      selectedTruckItem: 0,
      selectedDispatcherItem: 0,
      selectedDriverItem: 0,
      trucksTabs: 0,
      driversList: [],
      driversListMore: [],
      driversOOList: [],
      driversTabs: 0,
      driversOOTabs: 0,
      dispatchersList: [],
      dispatchersTabs: 0,
      truckReportKey: 0,
      loadsReportKey: 0,
      invoicesReportKey: 0,
      driversReportKey: 0,
      driversOOReportKey: 0,
      dispatchersReportKey: 0,
      isTimeframeChangedFlag: false,
      selectedStr: '',
      payedLoadId: 0,
      payedLoadsIds: {},
      payedUserId: 0,
      maxVisibleTabs: 1,
      importModal: false,
      importLoading: false,
      importPilotLoading: false,
      importFleetOneLoading: false,
      importTCSLoading: false,
      importItems: [],
      importHeaders: [],
      importMap: {},
      importSelected: [],
      importSearch: '',
      importNewCount: 0,
      importImportedCount: 0,
      hideImported: true,
      mapModal: false,
      mapModalLocations: [],
      mapModalStartLocation: '',
      mapModalEndLocation: '',
      mapModalStarted: 0,
      mapModalEnded: 0,
      mapModalLoadId: 0,
      mapModalLoadTrucks: [],
      osmMapFloatingKey: 'osmMapFloatingKey' + new Date().getTime(),
      reportTypesItems: [
        { value: 'trucks', text: this.$root.t('Reports.Trucks') },
        { value: 'loads', text: this.$root.t('Reports.Loads') },
        { value: 'invoices', text: this.$root.t('Reports.Invoices') },
        { value: 'drivers', text: this.$root.t('Reports.Drivers') },
        { value: 'driversOO', text: this.$root.t('Reports.DriversOO') },
        { value: 'dispatchers', text: this.$root.t('Reports.Dispatchers') },
        { value: 'loadsFeed', text: this.$root.t('Reports.LoadsFeed') },
        { value: 'loadsRefines', text: this.$root.t('Reports.LoadsRefines') },
        { value: 'truckMaintenance', text: this.$root.t('Reports.TruckMaintenance') },
        { value: 'expenses', text: this.$root.t('Reports.Expenses') }
      ],
      osmMapKey: new Date().getTime()
    };
  },
  computed: {
    importItemsFiltered() {
      let result = [];
      for (let i = 0; i < this.importItems.length; i++) {
        if (!this.hideImported || !this.importItems[i].exists) {
          result.push(this.importItems[i]);
        }
      }
      return result;
    },
    substractIntervalCode () {
      if (this.mode === 'day') {
        return 'd';
      } else if (this.mode === 'week') {
        return 'w';
      } else if (this.mode === 'month') {
        return 'M';
      } else if (this.mode === 'year') {
        return 'Y';
      }
      return 'd';
    },
    isRangeMode () {
      return this.mode === 'range';
    }
  },
  mounted () {
    if (this.$vuetify.breakpoint.xs) {
      this.maxVisibleTabs = 1;
    } else if (this.$vuetify.breakpoint.sm) {
      this.maxVisibleTabs = 2;
    } else if (this.$vuetify.breakpoint.md) {
      this.maxVisibleTabs = 3;
    } else if (this.$vuetify.breakpoint.lg) {
      this.maxVisibleTabs = 5;
    } else if (this.$vuetify.breakpoint.xl) {
      this.maxVisibleTabs = 7;
    }

    if (this.$root.getLocalStorageItem('reportsTimeFrame')) {
      this.timeframe = this.$root.getLocalStorageItem('reportsTimeFrame');
      this.mode = this.timeframe;

      if (!this.$root.getLocalStorageItem('reportsDateRangeFrom')) {
        this.isTimeframeChangedFlag = true;
      }
    }
    if (this.$root.getLocalStorageItem('reportsDateRangeFrom') && this.$root.getLocalStorageItem('reportsDateRangeFrom') !== undefined) {
      this.dateRange[0] = this.$root.getLocalStorageItem('reportsDateRangeFrom');
    }

    if (this.$root.getLocalStorageItem('reportsDateRangeTo') && this.$root.getLocalStorageItem('reportsDateRangeTo') !== undefined) {
      this.dateRange[1] = this.$root.getLocalStorageItem('reportsDateRangeTo');
    }

    if (this.$route.params.type) {
      this.tab = this.$route.params.type === 'driversLoads' ? 'drivers' : this.$route.params.type;
    }

    if (this.$root.getLocalStorageItem('reportsDateOffset')) {
      this.offset = parseInt(this.$root.getLocalStorageItem('reportsDateOffset'));
    }

    if (this.$route.params.item) {
      this.trucksTabs = 'truck_' + this.$route.params.item;
      this.driversTabs = 'driver_' + this.$route.params.item;
      this.driversOOTabs = 'driverOO_' + this.$route.params.item;
      this.dispatchersTabs = 'dispatcher_' + this.$route.params.item;
    } else {
      this.trucksTabs = 'truck_all';
    }
    this.$nextTick(() => {
      /* if (this.timeframe_prop) {
                  this.timeframe = this.timeframe_prop;
                  this.mode = this.timeframe_prop;
              }
              if (this.date_range) {
                  this.dateRange[0] = this.$root.formatDate(this.date_range[0]);
                  this.dateRange[1] = this.$root.formatDate(this.date_range[1]);
              } */

      if (!this.dateRange[0] || !this.dateRange[1] || this.dateRange[0] === 'undefined' || !this.dateRange[1] === 'undefined') {
        this.updateDatesRange(true);
      } else {
        this.dateRangeOptions.startDate = this.dateRange[0];
        this.dateRangeOptions.endDate = this.dateRange[1];
        this.dateRangePickerKey = new Date().getTime();
      }

      if (this.$root.isFullFinancialDataAllowedToView) {
        const storedPath = this.$root.getLocalStorageItem('reportTypePath');
        if (storedPath && this.$route.path === '/reports' && storedPath !== this.$route.path) {
          this.$root.route(storedPath);
        }
      }
      this.refreshLists();
      this.mounted = true;
    });

    if (this.$route.params.type === 'trucks' && this.$route.params.item > 0) {
      this.selectedTruckItem = parseInt(this.$route.params.item);
    }
    if (this.$route.params.type === 'dispatchers' && this.$route.params.item > 0) {
      this.selectedDispatcherItem = parseInt(this.$route.params.item);
    }
    if ((this.$route.params.type === 'drivers' || this.$route.params.type === 'driversLoads') && this.$route.params.item > 0) {
      this.selectedDriverItem = parseInt(this.$route.params.item);
    }
  },
  methods: {
    getDriverFullNameById (id) {
      if (parseInt(id) === 0) {
        return this.$root.t('All');
      }
      const driver = this.driversList.find(el => parseInt(el.id) === parseInt(id));
      return driver ? driver.fullName : '';
    },
    onReportSubTypeChanged (path) {
      this.$root.setLocalStorageItem('reportTypePath', path);
      this.$root.route(path);
    },
    onReportTypeChanged (path = '') {
      if (path !== '') {
        this.$root.setLocalStorageItem('reportTypePath', path);
        this.$root.route(path);
        return;
      }

      switch (this.tab) {
        case 'trucks':
          this.$root.route('/reports/trucks/');
          break;
        case 'loads':
          this.$root.route('/reports/loads');
          break;
        case 'invoices':
          this.$root.route('/reports/invoices');
          break;
        case 'drivers':
          this.$root.route('/reports/driversLoads/');
          break;
        case 'driversOO':
          this.$root.route('/reports/driversOO/');
          break;
        case 'dispatchers':
          this.$root.route('/reports/dispatchers/');
          break;
        case 'loadsFeed':
          this.$root.route('/reports/loadsFeed/');
          break;
        case 'loadsRefines':
          this.$root.route('/reports/loadsRefines/');
          break;
        case 'truckMaintenance':
          this.$root.route('/reports/truckMaintenance/');
          break;
        case 'expenses':
          this.$root.route('/reports/expenses/');
          break;
      }
    },
    addDriverTab (driver) {
      /* const removed = this.driversList.splice(0, 1)
              this.driversList.push(
                  ...this.driversListMore.splice(this.driversListMore.indexOf(driver), 1),
              )
              this.driversListMore.push(...removed)
              this.$nextTick(() => { this.driversTabs = 'driver_' + driver.id }) */
      this.onReportTypeChanged('/reports/drivers/' + driver.id);
    },
    onSelected (selectedArray) {
      this.selectedStr = selectedArray.join(',');
    },
    remountReports () {
      this.truckReportKey = new Date().getTime();
      this.loadsReportKey = new Date().getTime();
      this.invoicesReportKey = new Date().getTime();
      this.driversReportKey = new Date().getTime();
      this.driversOOReportKey = new Date().getTime();
      this.dispatchersReportKey = new Date().getTime();
    },
    onTimeFrameChanged () {
      this.isTimeframeChangedFlag = true;
      this.timeframe = this.mode;
      this.offset = 0;
      this.updateDatesRange(true);
      this.$forceUpdate();
      this.$root.setLocalStorageItem('reportsTimeFrame', this.timeframe);
      this.$root.removeFromLocalStorageItem('reportsDateRangeFrom');
      this.$root.removeFromLocalStorageItem('reportsDateRangeTo');
      this.$root.removeFromLocalStorageItem('reportsDateOffset');
      this.selectedStr = '';
    },
    updateDatesRange (isTimeFrame = false) {
      this.isTimeframeChangedFlag = isTimeFrame;
      if (this.mode === 'all') {
        this.dateRange[0] = '01/01/1900';
        this.dateRange[1] = '01/01/3000';
      } else {
        this.dateRange[0] = this.$moment.moment().utcOffset(this.$store.getters.timezoneOffsetMinutes).subtract(this.offset, this.substractIntervalCode).startOf(this.mode).format('MM/DD/YYYY');
        this.dateRange[1] = this.$moment.moment().utcOffset(this.$store.getters.timezoneOffsetMinutes).subtract(this.offset, this.substractIntervalCode).endOf(this.mode).format('MM/DD/YYYY');
      }
      this.dateRangeOptions.startDate = this.dateRange[0];
      this.dateRangeOptions.endDate = this.dateRange[1];
      this.dateRangePickerKey = new Date().getTime();

      if (!isTimeFrame) {
        this.$root.setLocalStorageItem('reportsDateRangeFrom', this.dateRange[0]);
        this.$root.setLocalStorageItem('reportsDateRangeTo', this.dateRange[1]);
      }

      this.refreshLists();
    },
    prevInterval () {
      this.offset++;
      this.$root.setLocalStorageItem('reportsDateOffset', this.offset);
      this.updateDatesRange(this.mode !== 'range');
      this.remountReports();
      this.$forceUpdate();
    },
    nextInterval () {
      if (this.offset === 0) return;
      this.offset--;
      this.$root.setLocalStorageItem('reportsDateOffset', this.offset);
      this.updateDatesRange(this.mode !== 'range');
      this.remountReports();
      this.$forceUpdate();
    },
    dateRangeChange () {
      this.remountReports();
      this.$forceUpdate();

      if (!this.isTimeframeChangedFlag) {
        if (!this.dateRange[0] || !this.dateRange[1] || this.dateRange[0] === 'undefined' || !this.dateRange[1] === 'undefined') {
          this.mode = 'month';
          //this.dateRange[0] = this.$moment.moment().utcOffset(this.$store.getters.timezoneOffsetMinutes).subtract(this.offset, this.substractIntervalCode).startOf(this.mode).format('MM/DD/YYYY');
          //this.dateRange[1] = this.$moment.moment().utcOffset(this.$store.getters.timezoneOffsetMinutes).subtract(this.offset, this.substractIntervalCode).endOf(this.mode).format('MM/DD/YYYY');
          this.$root.setLocalStorageItem('reportsDateRangeFrom', this.dateRange[0]);
          this.$root.setLocalStorageItem('reportsDateRangeTo', this.dateRange[1]);
        }
        else {
          this.$root.setLocalStorageItem('reportsDateRangeFrom', this.dateRange[0]);
          this.$root.setLocalStorageItem('reportsDateRangeTo', this.dateRange[1]);
          this.mode = 'range';
        }
      }
      this.isTimeframeChangedFlag = false;
      this.selectedStr = '';
    },
    importExpensesUpload (e, source) {
      const file = e.target.files.length > 0 ? e.target.files[0] : null;
      if (file) {
        if (source === 'pilot')
          this.importPilotLoading = true;
        else if (source === 'fleetOne')
          this.importFleetOneLoading = true;
        else if (source === 'tcs')
          this.importTCSLoading = true;

        this.$root.readWithFileReader(file, (result) => {
          let formData = new FormData();
          formData.append('file', file);
          // Make the request to the POST /single-file URL
          this.$root.post('/api/xlsx/parse/' + source, formData, {
            baseURL: this.$store.getters.host,
            headers: { 'Content-Type': 'multipart/form-data' }
          }).then( (response) => {
            if (response.status === 'ok') {
              this.importItems = [];
              this.importHeaders = [];
              this.importMap = {};
              //this.$set(this, 'importData', response.results);
              if (response.results.length > 0) {
                this.importHeaders = [
                  { text: '', value: 'importBtn'},
                  { text: 'Loads', value: 'loadId' },
                  { text: 'Drivers', value: 'driverId' },
                  { text: "Card #", value: "Card #" },
                  { text: "Trx Date", value: "Trx Date" },
                  { text: "Transaction #", value: "Transaction #" },
                  { text: "Store", value: "Store Number" },
                  { text: "Store City", value: "Store City" },
                  { text: "Store State", value: "Store State" },
                  { text: "Product", value: "Product" },
                  { text: "Driver", value: "Driver" },
                  { text: "Odometer", value: "Odometer" },
                  { text: "Vehicle", value: "Vehicle" },
                  { text: "Quantity", value: "Quantity" },
                  { text: "Invoice Amount", value: "Invoice Amount" },
                ];

                for (const [key, value] of Object.entries(response.results[0])) {
                  //this.importHeaders.push({ text: key, value: key });
                  if (key === "Card #") this.importMap[key] = "Card";
                  if (key === "Trx Date") this.importMap[key] = "TrxDate";
                  if (key === "Transaction #") this.importMap[key] = "Transaction";
                  if (key === "Store Number") this.importMap[key] = "StoreNumber";
                  if (key === "Store City") this.importMap[key] = "StoreCity";
                  if (key === "Store State") this.importMap[key] = "StoreState";
                  if (key === "Product") this.importMap[key] = "Product";
                  if (key === "Driver") this.importMap[key] = "Driver";
                  if (key === "Odometer") this.importMap[key] = "Odometer";
                  if (key === "Vehicle") this.importMap[key] = "Vehicle";
                  if (key === "Quantity") this.importMap[key] = "Quantity";
                  if (key === "Invoice Amount") this.importMap[key] = "InvoiceAmount";
                }

                this.importNewCount = 0;
                this.importImportedCount = 0;
                for (let i = 1; i < response.results.length; i++) {
                  if (response.results[i].exists) {
                    this.importImportedCount += 1;
                  } else {
                    this.importNewCount += 1;
                  }
                  this.importItems.push(response.results[i]);
                  this.importItems[this.importItems.length - 1].id = i;
                  this.importItems[this.importItems.length - 1].loadId = '';
                  for (let j = 0; j < this.importItems[this.importItems.length - 1].loads.length; j++ ) {
                    const _load = this.importItems[this.importItems.length - 1].loads[j];
                    this.importItems[this.importItems.length - 1].loadId += ' ' + _load.id;
                    this.importItems[this.importItems.length - 1].loadId += ' ' + _load.pickupLocationName;
                    this.importItems[this.importItems.length - 1].loadId += ' ' + _load.deliveryLocationName;
                    for (let k = 0; k < _load.drivers.length; k++) {
                      this.importItems[this.importItems.length - 1].loadId += ' ' + _load.drivers[k].name;
                    }
                  }
                }
              }
              this.importModal = true;
             } else if ( response.status === 'error') {
              this.$root.toast(response.msg, { color: 'error' });
            }
          }).catch( (error) => {
            console.error(error);
          }).finally(() => {
            e.target.value = '';
            if (source === 'pilot')
              this.importPilotLoading = false;
            else if (source === 'fleetOne')
              this.importFleetOneLoading = false;
            else if (source === 'tcs')
              this.importTCSLoading = false;
          });
        });
      }
    },
    importExpense(item) {
      if (item.loads.length === 0) {
        this.$root.toast(this.$i18n.t('Import.NoLoadWasSelected'), { color: 'error' });
        return;
      }
      if (item.loads[0] && item.loads[0].hasOwnProperty('id') && parseInt(item.loads[0].id) > 0) {
        let importItem = {};
        for (const [key, value] of Object.entries(item)) {
          if (this.importMap.hasOwnProperty(key)) {
            importItem[this.importMap[key]] = value;
          }
        }
        importItem.loadId = parseInt(item.loads[0].id);
        importItem.truckId = item.truckId;
        importItem.driverId = parseInt(item.loads[0].firstDriver);
        item.loading = true;
        this.addNewExpense(importItem).then((response) => {
          if (response.status === 'ok') {
            item.exists = true;
            this.$root.toast(this.$i18n.t('Import.ImportSuccess'), { color: 'success' });
          }
          item.loading = false;
        });
      } else {
        this.$root.toast(this.$i18n.t('Import.NoLoadWasSelected'), { color: 'error' });
      }
    },
    async importSelectedExpenses() {
      this.importLoading = true;
      for(let i = 0; i < this.importSelected.length; i++) {
        await this.importExpense(this.importSelected[i]);
      }
      this.importLoading = false;
    },
    openMapInModal (item, floating = false, event = null) {
      if (floating && this.$root.isUseGoogleMaps) return;
      const namesArray = item.name ? item.name.split('--') : [];
      this.$set(this, 'mapModalLocations', item.locations);
      this.$set(this, 'mapModalStarted', item.started);
      this.$set(this, 'mapModalEnded', item.ended);
      this.$set(this, 'mapModalLoadId', item.id);
      this.$set(this, 'mapModalLoadTrucks', item.trucks.map(truck => truck.id ?? truck.truckId));
      if (item.startLocation && item.endLocation) {
        this.$set(this, 'mapModalStartLocation', item.startLocation);
        this.$set(this, 'mapModalEndLocation', item.endLocation);
      } else if (namesArray.length > 1) {
        this.$set(this, 'mapModalStartLocation', namesArray[0].trim());
        this.$set(this, 'mapModalEndLocation', namesArray[1].trim());
      }
      if (floating && event && !this.$root.isUseGoogleMaps) {
        this.$root.floatingMap = true;
        let el = document.getElementById('floatingMapId');
        let posx = event.clientX + document.body.scrollLeft + 50;
        let posy = 100;
        el.style.left = posx + 'px';
        el.style.top = posy + 'px';
        el.style.zIndex = 100000;
        this.osmMapFloatingKey = 'osmMapFloatingKey' + new Date().getTime();
      } else {
        this.$set(this, 'mapModal', true);
      }
      this.$nextTick(() => {
        if (this.$root.isUseGoogleMaps) {
          //this.$refs.mapModalRef.init();
          setTimeout(() => {
            this.$refs.mapModalRef.init();
          }, 1000);
        } else {
          this.osmMapKey = new Date().getTime();
        }
        this.$forceUpdate();
      });
    },
    refreshLists () {
      if (this.$root.isFullFinancialDataAllowedToView) {
        if ((this.$route.params.type === 'drivers' || this.$route.params.type === 'driversLoads')) {
          this.getReportsDriversList(this.$root.parseDate(this.dateRange[0]), this.$root.parseDate(this.dateRange[1])).then((response) => {
            if (response.status === 'ok') {
              this.driversList = [];
              let drivers = response.result.data;
              for (let i = 0; i < drivers.length; i++) {
                if (parseInt(drivers[i].statusIsActive) === 0) continue;
                drivers[i]['fullName'] = drivers[i].firstName + ' ' + (drivers[i].lastName ? drivers[i].lastName : '');
                drivers[i]['avatarLetters'] = (drivers[i].firstName && drivers[i].lastName) ? drivers[i].firstName.charAt(0) + drivers[i].lastName.charAt(0) : '';
                this.driversList.push(drivers[i]);
                /* if (this.driversList.length < this.maxVisibleTabs || parseInt(drivers[i].id) === parseInt(this.$route.params.item)) {
                  this.driversList.push(drivers[i]);
                } else {
                  this.driversListMore.push(drivers[i]);
                } */
              }
              this.driversList.unshift({ id: 0, fullName: 'All' });
            }
          });
        }

        if (this.$route.params.type === 'trucks') {
          this.getReportsTrucksList(this.$root.parseDate(this.dateRange[0]), this.$root.parseDate(this.dateRange[1])).then((response) => {
            if (response.status === 'ok') {
              this.trucksList = response.result;
              this.trucksList.unshift({id: 0, name: 'All'});
            }
          });
        }

        if (this.$route.params.type === 'driversOO' && !this.$route.params.item) {
          this.getReportsDriversOOList(this.$root.parseDate(this.dateRange[0]), this.$root.parseDate(this.dateRange[1])).then((response) => {
            if (response.status === 'ok') {
              this.driversOOList = [];
              let drivers = response.result.data;
              for (let i = 0; i < drivers.length; i++) {
                if (parseInt(drivers[i].statusIsActive) === 0) continue;
                drivers[i]['fullName'] = drivers[i].firstName + ' ' + (drivers[i].lastName ? drivers[i].lastName : '');
                drivers[i]['avatarLetters'] = (drivers[i].firstName && drivers[i].lastName) ? drivers[i].firstName.charAt(0) + drivers[i].lastName.charAt(0) : '';
                this.driversOOList.push(drivers[i]);
              }
              this.driversOOList.unshift({id: 0, fullName: 'All'});
            }
          });
        }

        if (this.$route.params.type === 'dispatchers') {
          this.getReportsDispatchersList(this.$root.parseDate(this.dateRange[0]), this.$root.parseDate(this.dateRange[1])).then((response) => {
            if (response.status === 'ok') {
              this.dispatchersList = [];
              let dispatchers = response.result.data;
              for (let i = 0; i < dispatchers.length; i++) {
                if (parseInt(dispatchers[i].statusIsActive) === 0) continue;
                dispatchers[i]['fullName'] = dispatchers[i].firstName + ' ' + (dispatchers[i].lastName ? dispatchers[i].lastName : '');
                dispatchers[i]['avatarLetters'] = (dispatchers[i].firstName && dispatchers[i].lastName) ? dispatchers[i].firstName.charAt(0) + dispatchers[i].lastName.charAt(0) : '';
                this.dispatchersList.push(dispatchers[i]);
              }
              this.dispatchersList.unshift({id: 0, fullName: 'All'});
            }
          });
        }
      }
    }
  }
};
</script>
